export default __webpack_public_path__ + "media/images/mailer/wordmark-d809fcda5d32d04b9d0278b0c053c3e7.png";